import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import Badge from "../../components/common/Badge";
import Fld from "../../components/common/Fld";
import ImgUploadFld from "../../components/common/ImgUploadFld";
import Dlg from "../../components/common/Dlg";
import { ABt } from "../AdminUI";

export default function TeamTab() {
  const { db, saveDB, delDB } = useData();
  const { toast } = useOutletContext();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fs = k => v => setForm(f => ({ ...f, [k]: v }));
  const close = () => { setModal(false); setForm({}); };
  const save = r => { saveDB("team", r); toast(r.id ? "Updated" : "Added"); close(); };
  const del = id => { delDB("team", id); toast("Deleted"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <ABt variant="orange" onClick={() => { setForm({ name: "", role: "", bio: "", photo: "", linkedin: "", status: "active" }); setModal(true); }}>+ Add Member</ABt>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
        {(db.team || []).map(m => (
          <div key={m.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "18px 16px", textAlign: "center", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
            {m.photo
              ? <img src={m.photo} alt={m.name} style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover", margin: "0 auto 10px", display: "block", border: "2px solid " + C.border }} />
              : <div style={{ width: 60, height: 60, borderRadius: "50%", background: "linear-gradient(135deg," + C.blue + "," + C.blue2 + ")", color: "#fff", fontSize: 22, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 10px" }}>{m.name.charAt(0)}</div>
            }
            <div style={{ fontWeight: 700, color: C.blue, fontSize: 14, marginBottom: 3 }}>{m.name}</div>
            <div style={{ fontSize: 12, color: C.orange, fontWeight: 600, marginBottom: 5 }}>{m.role}</div>
            <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.55, marginBottom: 8 }}>{m.bio}</div>
            <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 6 }}><Badge v={m.status} /></div>
            <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
              <ABt variant="amber" onClick={() => save({ ...m, status: m.status === "active" ? "inactive" : "active" })}>{m.status === "active" ? "Hide" : "Show"}</ABt>
              <ABt onClick={() => { setForm({ ...m }); setModal(true); }}>Edit</ABt>
              <ABt variant="red" onClick={() => del(m.id)}>Del</ABt>
            </div>
          </div>
        ))}
      </div>

      {modal && <Dlg title={form.id ? "Edit Team Member" : "Add Team Member"} onClose={close}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="Full Name" value={form.name || ""} onChange={fs("name")} /><Fld label="Role" value={form.role || ""} onChange={fs("role")} /></div>
        <Fld label="Bio" value={form.bio || ""} onChange={fs("bio")} rows={2} />
        <ImgUploadFld label="Photo" value={form.photo || ""} onChange={fs("photo")} round w={56} h={56} maxDim={500} />
        <Fld label="LinkedIn URL" value={form.linkedin || ""} onChange={fs("linkedin")} />
        <Fld label="Status" value={form.status || "active"} onChange={fs("status")} opts={["active", "inactive"]} />
        <ABt variant="orange" onClick={() => save(form)}>{form.id ? "Update" : "Add"} Member</ABt>
      </Dlg>}
    </>
  );
}
